import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { bool, func, node, number, oneOfType, string } from 'prop-types';
import { ContainerItem } from './dropdown.styles';
import { useDropdownContext } from './dropdown-context';

const DropdownItem = _ref => {
  let {
    children,
    value,
    startIcon,
    endIcon
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "value", "startIcon", "endIcon", "onClick"]);

  const {
    setIsOpen,
    handleOnChange
  } = useDropdownContext();

  const handleOnClick = e => {
    setIsOpen(false);
    handleOnChange(e, {
      value
    });
  };

  return /*#__PURE__*/React.createElement(ContainerItem, _extends({}, props, {
    role: "option",
    onClick: handleOnClick,
    "data-testid": "dropdown-item"
  }), startIcon, children, endIcon);
};

process.env.NODE_ENV !== "production" ? DropdownItem.propTypes = {
  children: node,
  value: oneOfType([number, string]),
  startIcon: node,
  endIcon: node,
  forwardedAs: string,
  fontSize: oneOfType([string, number]),
  disableHover: bool,
  onClick: func
} : void 0;
DropdownItem.defaultProps = {
  children: null,
  value: null,
  startIcon: null,
  endIcon: null,
  disableHover: false,
  forwardedAs: 'li'
};
DropdownItem.displayName = 'DropdownItem';
export default DropdownItem;